import * as React from 'react';
import { MvkThumbnailContainer } from './MvkThumbnailContainer';
import { PlanThumbnailContainer } from './PlanThumbnailContainer';
import { VirtualTourThumbnailContainer } from './VirtualTourThumbnailContainer';
import { TourThumbnails } from './TourThumbnails';
import { VideoThumbnailContainer } from './VideoThumbnailContainer';

export const TourThumbnailsContainer = () => {
  return (
    <TourThumbnails>
      <>
        <PlanThumbnailContainer />
        <VirtualTourThumbnailContainer />
        <VideoThumbnailContainer />
        <MvkThumbnailContainer />
      </>
    </TourThumbnails>
  );
};

TourThumbnailsContainer.displayName = 'TourThumbnailsContainer';
